import React from 'react';

import {
  useReturnLabelSettingsWidgetQuery,
  useSaveTier1PrintRequestLabelTypeMutation
} from 'generated/graphql';

import * as types from './types';



export interface IData {
  formState: types.IFormState;
}

export function useQuery(storeId: string) {
  const tuple = useReturnLabelSettingsWidgetQuery({
    variables: {
      storeId
    }
  });

  return React.useMemo(
    () => {
      const data: IData = {
        formState: {
          returnLabelType: tuple.data?.store?.tier1PrintRequestLabelType ?? '',
          printRequestFunctionInternalId: tuple.data?.store?.printRequestFunctionInternalId ?? '',
          printRequestLabelInternalId: tuple.data?.store?.printRequestLabelInternalId ?? '',
          printRequestPrinterInternalId: tuple.data?.store?.printRequestPrinterInternalId ?? ''
        }
      };

      return {
        ...tuple,
        data
      };
    },
    [tuple]
  );
}



export function useSavePrintRequestLabelType(storeId: string) {
  const [fnMutate, tuple] = useSaveTier1PrintRequestLabelTypeMutation({
    refetchQueries: []
  });

  const fnWrappedMutate = React.useCallback(
    async (formState: types.IFormState) => {
      await fnMutate({
        variables: {
          storeId,
          tier1PrintRequestLabelType: formState.returnLabelType,
          printRequestFunctionInternalId: formState.printRequestFunctionInternalId,
          printRequestLabelInternalId: formState.printRequestLabelInternalId,
          printRequestPrinterInternalId: formState.printRequestPrinterInternalId
        }
      });
    },
    [
      storeId,
      fnMutate
    ]
  );

  return React.useMemo(
    () => [
      fnWrappedMutate,
      {
        ...tuple,
        data: null
      }
    ] as const,
    [
      fnWrappedMutate,
      tuple
    ]
  );
}
